import React, { Component } from "react";
import { Map, Marker, TileLayer } from "react-leaflet";
import "../styles/locationMap.scss";

export default class LocationMap extends Component {
  render() {
    return (
      <div className="face-matching-location-container">
        <Map center={this.props.location} zoom={15}>
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={this.props.location}></Marker>
        </Map>
      </div>
    );
  }
}
